import * as type from "@common/constants/actionTypes";
import { push } from "connected-react-router";
import * as authenticationService from "../services/authenticationService";
import { routes } from "@common/constants/urls";
import mqttService from "@monitor/mqttService";
import { post as apiPost } from "@common/services/request";

const attemptAuthentication = (credentials) => {
  return { type: type.AUTHENTICATE_USER, credentials };
};

const authenticationSuccess = (token) => {
  return { type: type.AUTHENTICATE_USER_SUCCESS, token };
};

const authenticationError = (message) => {
  return { type: type.AUTHENTICATE_USER_ERROR, message };
};

export const authenticateUser = (credentials, headers) => {
  return async (dispatch) => {
    // email to lowercase, because the backend lowercases all emails.
    credentials.email = credentials.email.toLowerCase();
    dispatch(attemptAuthentication(credentials));

    try {
      const data = await authenticationService.authenticateUser(
        credentials,
        headers,
      );

      // Just in case the server won't respond with an error code but won't send the jwt either
      if (!data.token) {
        dispatch(authenticationError("Error retrieving token."));
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("exp", data.exp * 1000);

      if (window.OneSignalDeferred) {
        window.OneSignalDeferred.push(async function (OneSignal) {
          if (OneSignal?.User?.PushSubscription) {
            const registerPlayerId = async function (playerId) {
              if (playerId) {
                localStorage.setItem("oneSignalPlayerId", playerId);

                try {
                  await apiPost("v1/push/register/", { player_id: playerId });
                } catch (error) {
                  let errorDetails = error;
                  if (error && typeof error.then === "function") {
                    try {
                      errorDetails = await error;
                    } catch (e) {
                      errorDetails = e;
                    }
                  }
                  console.error(
                    "Failed to register OneSignal player ID on backend:",
                    errorDetails,
                  );
                }
              }
            };

            const currentId = OneSignal?.User?.PushSubscription?.id;
            if (currentId) {
              await registerPlayerId(currentId);
            }

            OneSignal?.User?.PushSubscription?.addEventListener(
              "change",
              function (event) {
                const newId = event?.current?.id;
                if (newId) {
                  registerPlayerId(newId);
                }
              },
            );
          }
        });
      }

      dispatch(authenticationSuccess(data.token));

      // Subscription status is resolved and persisted server-side at login
      // (see minibrew-platform CustomTokenObtainPairSerializer). The portal
      // renders from the synced access_type, so every login lands here.
      dispatch(push(routes.brewery));
    } catch (err) {
      console.error(err);
      // TODO: consider handling errors at a different point in the application (homogenize responses from backend?)
      if (typeof err === "string") {
        dispatch(authenticationError(err));
      } else if (err.message) {
        dispatch(authenticationError(err.message));
      } else if (err && typeof err.then === "function") {
        try {
          await err;
          dispatch(authenticationError("Incorrect credentials")); // Some error messages come with 'custom permission django'
        } catch {
          // ignore or handle
        }
      } else {
        dispatch(authenticationError("Incorrect credentials"));
      }
    }
  };
};

export const signOut = () => {
  // TODO: would be cleaner to take care of setting and removing the token in a middleware
  if (mqttService.connected == true) {
    mqttService.end(() => {
      console.log("ended connection");
    });
  }
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("exp");
  localStorage.removeItem("is_impersonating");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("userId");
  sessionStorage.removeItem("exp");
  sessionStorage.removeItem("is_impersonating");

  if (window.OneSignalDeferred) {
    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        await OneSignal.logout();
      } catch (err) {
        console.error("Failed to log out of OneSignal:", err);
      }
    });
  }

  return {
    type: type.SIGN_OUT,
  };
};
